import { SET_LOGIN_STATE } from './actionTypes';

import { Map } from 'immutable';

const initialState = Map({
  payload: Map({
    type: '',
    auth: true,
  }),
});

function reducer(state = initialState, action): any {
  const { type } = action;

  if (type === SET_LOGIN_STATE) {
    const { payload } = action;
    return state.updateIn(['type'], () => type).setIn(['payload'], Map(payload));
  }

  return state;
}

export default reducer;
